import type { Block } from '@contentful/rich-text-types'
import type { ReactElement, ReactNode } from 'react'

import { Text } from '@components/ui-core/text/text'

import styles from './rich-text.module.scss'

interface ListItemProps extends Block {
  children?: ReactNode
}

export function ListItem(props: ListItemProps): ReactElement {
  const { children } = props

  return (
    <li className={styles.listItem}>
      <Text as="span" variant="bodySmall">
        {children}
      </Text>
    </li>
  )
}
